//header top bar custom menu hide show


var paragraphs = document.querySelectorAll(".topbar_menu a");
var toggleClasses = document.querySelectorAll(".drop-menu-top"); // Selects multiple elements

if (paragraphs.length > 0 && toggleClasses.length > 0) {
  paragraphs.forEach(function (paragraph) {
    paragraph.addEventListener("click", function () {
      toggleClasses.forEach(function (toggleClass) {
        toggleClass.classList.add("main"); // Adds class to both elements
      });

      //paragraph.classList.add("active"); // Optional: Adds an active class to the clicked link
    });
  });
}


document.addEventListener("DOMContentLoaded", function () {
  document.querySelectorAll(".recommended_item").forEach(function (item) {
    const btn = item.querySelector(".recom_btn_custom");
    if (btn) {
      btn.addEventListener("click", function () {
        let var_id = item.getAttribute("data-pro-id");
        let qtyInput = item.querySelector(".reco-hover-qty .quantity-input");
        let qty = qtyInput ? qtyInput.value : 1;
        addItem1(var_id, qty);
      });
    }
  });

  // Quantity plus-minus functionality
  document.querySelectorAll(".recom_quantity").forEach(function (container) {
    container.addEventListener("click", function (event) {
      let button = event.target.closest(".quantity-button"); // Ensure the button is targeted

      if (button) {
        let input = container.querySelector(".quantity-input");
        let currentVal = parseInt(input.value, 10) || 1;

        if (button.classList.contains("feather-plus")) {
          currentVal += 1;
        } else if (button.classList.contains("feather-minus")) {
          currentVal = Math.max(currentVal - 1, 1);
        }

        input.value = currentVal;

        // Update the "Add to Cart" button state
        let addToCartButton = container.closest(".recommended_item").querySelector(".recom_btn_custom");
        if (addToCartButton) {
          addToCartButton.setAttribute('data-quantity', currentVal);
        }

        // Prevent rapid clicks by temporarily disabling the button
        button.disabled = true;
        setTimeout(() => {
          button.disabled = false;
        }, 100);
      }
    });
  });

  // Mobile recommended add-to-cart
  document.addEventListener("click", function (event) {
    if (event.target.classList.contains("reco-try-plus")) {
      event.preventDefault();
      let item = event.target.closest(".recommended_item");
      let var_id = item ? item.getAttribute("data-pro-id") : null;
      let qty = item ? item.querySelector(".quantity-input").value : 1;
      if (var_id) {
        addItem1(var_id, qty);
      }
    }
  });

  function addItem1(variant, qty) {
    let proObj = {
      id: variant,
      quantity: qty || 1,
      sections: "cart-notification-content,cart-notification-crosssell-product",
    };

    fetch("/cart/add.js", {
      method: "POST",
      headers: { "Accept": "application/json", "Content-Type": "application/json" },
      body: JSON.stringify(proObj),
    })
      .then((response) => response.json())
      .then((response) => {
        onItemAdded(response);
        const this_cartDrawer = document.querySelector('cart-drawer');
        this_cartDrawer.refresh(true);
        fetch("/cart.js")
          .then((res) => res.json())
          .then((cart) => {
            let cartData = cart.items;
            if (cartData.length > 0) {
              cartData.forEach((item) => {
                if (item.id == variant) {
                  let targetItem = document.querySelector(`.recommended_item[data-pro-id="${item.id}"]`);
                  console.log("targetItem", targetItem);
                  if (targetItem) {
                    targetItem.querySelector(".reco-try-plus").classList.add("hidden");
                    targetItem.querySelector(".reco-qty").textContent = item.quantity;
                  }
                }
              });
            }
          });
      })
      .catch((error) => {
        console.error("Error:", error);
      });
  }

    function onItemAdded(response) {
      var cartNotification = document.querySelector('cart-notification');
      cartNotification?.renderContents(response);
    }
});

